import { createThirdwebClient, defineChain } from "thirdweb";
import { base, polygon } from "thirdweb/chains";

// Create thirdweb client
// Get your client ID from https://thirdweb.com/dashboard
const clientId = import.meta.env.VITE_THIRDWEB_CLIENT_ID;

if (!clientId && import.meta.env.PROD) {
  console.warn(
    "VITE_THIRDWEB_CLIENT_ID is not set. In-app wallets and some features may not work."
  );
}

export const client = createThirdwebClient({
  clientId: clientId || "dev-mode", // Falls back for development
});

// Supported chains
export const supportedChains = [base, polygon] as const;

// Primary chain (Base for FreakMe.fun)
export const primaryChain = base;

// Custom chain definition if needed (example for custom RPC)
export const customBase = defineChain({
  id: 8453,
  name: "Base",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  rpc: import.meta.env.VITE_BASE_RPC_URL || "https://mainnet.base.org",
  blockExplorers: [
    {
      name: "Basescan",
      url: "https://basescan.org",
    },
  ],
});

// Wallet configuration for in-app wallets
export const walletConfig = {
  // Enable social login options
  inAppWallet: {
    auth: {
      options: ["email", "google", "apple", "discord"] as const,
    },
  },
  // Theme configuration matching FreakMe.fun branding
  theme: {
    colors: {
      primaryButtonBg: "#ff3366",
      primaryButtonText: "#ffffff",
      connectedButtonBg: "#1a1a2e",
      connectedButtonBgHover: "#2a2a4e",
      modalBg: "#0f0f1a",
      borderColor: "#ff336633",
      accentText: "#ff3366",
      secondaryText: "#a0a0b0",
    },
    fontFamily: "system-ui, -apple-system, sans-serif",
  },
};
